import { useState, useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
const services = [{
  image: "https://tm-plant.co.uk/wp-content/uploads/2026/07/RIDE-ON-MOWER-1.jpg?v=vhn4fszy4vk",
  alt: "Professional ride-on mower repair and servicing in Carlisle Cumbria",
  title: "\n",
  description: "Ride-On Mower Repair & Servicing\n\nKeep your ride-on mower running smoothly with our professional repair and servicing solutions. We provide expert maintenance, diagnostics, and repairs for domestic and commercial ride-on lawn mowers, helping you maximise performance, reliability, and the lifespan of your machine. Whether your ride-on mower won't start, has engine problems, poor cutting performance, steering issues, or transmission faults, our experienced technicians can quickly diagnose and repair the problem using quality replacement parts."
}, {
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/chainsaw.jpg",
  alt: "Expert chainsaw repair and strimmer servicing by certified technicians in Carlisle",
  title: "Chainsaw Repair & Servicing",
  description: "\nKeep your petrol chainsaws running at peak performance with our expert repair and servicing solutions. We provide thorough diagnostics, carburettor tuning, chain sharpening, bar replacement, engine overhauls, and safety brake checks for domestic and commercial users across Cumbria\n\nWhether your chainsaw fails to start, lacks power, leaks chain oil, or has ignition and carburetor issues, our experienced technicians ensure safe, reliable, and efficient operation using high-quality replacement parts."
}, {
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/blower.png",
  alt: "Construction equipment and plant machinery repair services Carlisle Cumbria",
  title: "",
  description: "Strimmer, Brushcutter & Leaf Blower Repair & Servicing\n\nKeep your garden equipment in top working condition with our professional repair and servicing solutions. We provide expert maintenance, diagnostics, and repairs for strimmers, brushcutters, and leaf blowers, helping homeowners, gardeners, landscapers, and commercial contractors get the best performance from their machines.\n\nWhether your equipment won't start, has lost power, vibrates excessively, leaks fuel, or simply needs routine maintenance, our experienced technicians can quickly identify the problem and carry out reliable, cost-effective repairs using high-quality replacement parts."
}, {
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/paslode.png",
  alt: "Gas nail gun repair and professional tool servicing Carlisle",
  title: "\n",
  description: "Gas Nail Gun Repair & Servicing\n\nKeep your Gas nail gun performing at its best with our professional repair and servicing solutions. We specialise in the maintenance, diagnostics, and repair of cordless gas nail guns, helping tradespeople and DIY users keep their tools reliable, safe, and ready for the job.\n\nWhether your nail gun won't fire, misfires, jams frequently, loses power, or simply requires routine servicing, our experienced technicians can quickly diagnose the fault and carry out high-quality repairs using genuine or premium replacement parts."
}, {
  image: "https://tm-plant.co.uk/wp-content/uploads/2026/07/stone-saw.jpg?v=93sk1hqnt4k",
  alt: "Stone saw, plate compactor, diesel mixer and generator repair Cumbria",
  title: "\n",
  description: "Stone Saw, Plate Compactor, Diesel Mixer & Generator Repair & Servicing\n\nWe provide expert repair and servicing for a wide range of construction and site equipment, helping builders, contractors, landscapers, and plant hire companies keep their machinery operating safely and efficiently. Our experienced technicians offer fast diagnostics, reliable repairs, and preventative maintenance to minimise downtime and maximise productivity.\n\nWhether your machine won't start, has lost power, suffers from engine or electrical faults, or simply requires routine servicing, we deliver professional solutions using high-quality replacement parts."
}, {
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/kosiarka.jpg",
  alt: "Walk-behind lawn mower repair and blade sharpening Carlisle",
  title: "Lawn Mower Repair & Servicing\n\n",
  description: "Professional lawn mower maintenance and repair services for walk-behind mowers. Our expert technicians provide comprehensive servicing including engine tuning for optimal performance, precision blade sharpening for efficient cutting, spark plug replacement and ignition system maintenance, seasonal preparation and storage services, fuel system cleaning and carburettor adjustment, belt and deck inspection, and general mechanical repairs. We ensure your mower runs smoothly and safely throughout the mowing season."
}];
export default function ServicesGrid() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);
  return <section ref={sectionRef} style={{
    backgroundColor: "rgb(249, 249, 246)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(26, 46, 32)",
    fontFamily: "Inter, sans-serif",
    paddingTop: "96px",
    paddingBottom: "32px",
    animation: "none 0s ease 0s 1 normal none running"
  }} className="!bg-[rgba(255,255,255,1)]">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Playfair+Display:wght@700&display=swap');
        @keyframes spin { 100% { transform: rotate(360deg); } }
        @keyframes pulse { 50% { opacity: 0.5; } }
        @keyframes enter {
          0% { opacity: var(--tw-enter-opacity,1); transform: translate3d(var(--tw-enter-translate-x,0),var(--tw-enter-translate-y,0),0)scale3d(var(--tw-enter-scale,1),var(--tw-enter-scale,1),var(--tw-enter-scale,1))rotate(var(--tw-enter-rotate,0)); filter: blur(var(--tw-enter-blur,0)); }
        }
        @keyframes exit {
          100% { opacity: var(--tw-exit-opacity,1); transform: translate3d(var(--tw-exit-translate-x,0),var(--tw-exit-translate-y,0),0)scale3d(var(--tw-exit-scale,1),var(--tw-exit-scale,1),var(--tw-exit-scale,1))rotate(var(--tw-exit-rotate,0)); filter: blur(var(--tw-exit-blur,0)); }
        }
        .service-card-link { display: block; text-decoration: none; }
        .service-card-link:hover .service-card-img { transform: scale(1.03); }
        .service-card-img { transition: transform 0.4s ease; }
        .service-card-link:hover .service-card-title { color: rgb(30, 64, 110); text-decoration: underline; }
      `}</style>

      <div className="page-container">
        <div className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => <Link key={service.image} to="#" className="service-card-link underline cursor-pointer" style={{
            color: "rgb(26, 46, 32)",
            fontFamily: "Inter, sans-serif",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "24px",
            border: "0px solid rgb(222, 222, 211)",
            animation: "none 0s ease 0s 1 normal none running"
          }}>
                <div className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDelay: `${index * 80}ms`
            }} data-index={index}>
                  <div className="overflow-hidden w-full" style={{
                aspectRatio: "469/352"
              }}>
                    <img src={service.image} alt={service.alt} className="service-card-img w-full h-full object-cover" style={{
                  display: "block"
                }} />
                  </div>
                  <div className="pt-4">
                    {service.title && service.title.trim() ? <h4 className="service-card-title mb-2 !font-thin !font-sans !text-lg" style={{
                  fontFamily: '"Playfair Display", serif',
                  fontSize: "22px",
                  fontWeight: "700",
                  color: "rgb(26, 46, 32)",
                  lineHeight: "28px",
                  transition: "color 0.2s ease"
                }}>
                        {service.title}
                      </h4> : null}
                    <h4 className="service-card-title mb-2 !font-extralight !font-sans !text-lg" style={{
                  fontFamily: '"Playfair Display", serif',
                  fontSize: "22px",
                  fontWeight: "700",
                  color: "rgb(26, 46, 32)",
                  lineHeight: "28px",
                  transition: "color 0.2s ease",
                  whiteSpace: "pre-line"
                }}>
                      {service.description}
                    </h4>
                  </div>
                </div>
              </Link>)}
          </div>
        </div>
      </div>
    </section>;
}